import Radio from "@/Components/UI/Forms/Radio";
import {
    REVIEW_OPTIONS,
    ResponseOption,
} from "@/Components/UI/Reviews/coachReviewOptions";

type CoachReviewImpactRadiosProps = {
    value: ResponseOption | undefined;
    onChange: (option: ResponseOption) => void;
    labelOverrides?: Partial<Record<ResponseOption, string>>;
};

export default function CoachReviewImpactRadios({
    value,
    onChange,
    labelOverrides = {},
}: CoachReviewImpactRadiosProps) {
    return (
        <div className="flex flex-col gap-3">
            {REVIEW_OPTIONS.map(({ key, text }) => (
                <Radio
                    key={key}
                    label={labelOverrides[key] ?? text}
                    checked={value === key}
                    onChange={() => onChange(key)}
                />
            ))}
        </div>
    );
}
